import { MOBILE_WIDTH } from '@common/constants/MEDIAS';
import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

export const eventListStyle = css`
  padding: 17px 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;

  @media (max-width: ${MOBILE_WIDTH}) {
    display: block;
  }
`;

export const eventListItemStyle = css`
  margin-bottom: 30px;
`;

export const orangeColor = css`
  color: ${palette.orange9};
`;

export const endColor = css`
  color: ${palette.gray5};
`;

export const eventDetailStyle = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 4px;
  color: ${palette.gray6};
  line-height: 17px;
`;

export const eventLinkImageStyle = css`
  position: relative;
  aspect-ratio: 2.5;
  overflow: hidden;
  border-radius: 4px;
`;

export const evnetbuttonStyle = css`
  background-color: transparent;
  position: absolute;
  top: 20px;
  right: 18px;
`;
